export class ExitStatusTypeValues {
    static readonly DRAFT = 'ExitDraft';
    static readonly PENDING ='ExitPending';
    static readonly ACCEPTED = 'ExitAccepted';
    static readonly DECLINED = 'ExitDeclined';
    static readonly INPROCESS = 'ExitInProcess';
    static readonly COMPLETED = 'ExitCompleted';
    static readonly ONHOLD = 'ExitOnHold';
    static readonly WITHDRAWN = 'ExitWithdrawn';
    static readonly EXTENDED = 'ExitExtended';
}

export class ExitStatusTypeIds {
    static readonly DRAFT = 10850;
    static readonly PENDING = 10851;
    static readonly ACCEPTED = 10852;
    static readonly DECLINED = 10853;
    static readonly INPROCESS = 10854;
    static readonly COMPLETED = 10857;
    static readonly ONHOLD = 10858;
    static readonly WITHDRAWN = 10855;
    static readonly EXTENDED = 13425;
}
